<div class="glxy-table-header">
  <div class="glxy-table-filter-and-search">
    <div class="filter-search-group">
      @if (showFilters) {
        @if (showFiltersButton) {
          <button
            mat-stroked-button
            class="table-btn glxy-filters-toggle"
            data-action="clicked-glxy-table-filters-toggle"
            [ngClass]="{ on: showFiltersOpen }"
            (click)="toggleFilterBar()"
          >
            <span class="glxy-filters-indicator-wrap table-btn-icon">
              <mat-icon>filter_list</mat-icon>
              @if (showFiltersApplied) {
                <span
                  class="glxy-filters-indicator"
                  [attr.aria-label]="'GALAXY.TABLE.FILTERS.APPLIED_INDICATOR' | translate"
                ></span>
              }
            </span>
            <span class="hide-on-small">{{ 'GALAXY.TABLE.FILTERS.TOGGLE_BUTTON' | translate }}</span>
          </button>
        } @else {
          <ng-content select="[filter-button]" />
        }
      }
      @if (showSearch) {
        <glxy-form-field class="glxy-table-search" suffixIcon="search" [showLabel]="false" [bottomSpacing]="false">
          <glxy-label>{{ 'GALAXY.TABLE.CONTENT_HEADER.SEARCH' | translate }}</glxy-label>
          <input
            type="search"
            [placeholder]="'GALAXY.TABLE.CONTENT_HEADER.SEARCH' | translate"
            matInput
            [formControl]="searchControl"
          />
        </glxy-form-field>
      }
    </div>
    <div class="after-search">
      <ng-content select="[after-search]" />
    </div>
  </div>

  <div class="glxy-table-actions">
    @if (showDisplayToggle) {
      <mat-button-toggle-group
        [value]="this.display()"
        (change)="onChangeDisplayOption($event.value)"
        class="toggle-btn"
      >
        <mat-button-toggle class="toggle-btn-icon" value="grid" data-action="clicked-glxy-table-display-options">
          <mat-icon>grid_view</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle class="toggle-btn-icon" value="list" data-action="clicked-glxy-table-display-options">
          <mat-icon>format_list_bulleted</mat-icon>
        </mat-button-toggle>
      </mat-button-toggle-group>
    }
    @if (showSort) {
      <button mat-stroked-button class="table-btn" data-action="clicked-glxy-table-sort">
        <span class="table-btn-icon"><mat-icon>sort</mat-icon></span>
        <span class="hide-on-small">{{ 'GALAXY.TABLE.CONTENT_HEADER.SORT' | translate }}</span>
      </button>
    }
    @if (showColumnArrange) {
      <glxy-column-sort [type]="columnArrangeType" />
    }
    @if (showExport) {
      <button mat-stroked-button class="table-btn" data-action="clicked-glxy-table-export" (click)="this.export.emit()">
        <span class="table-btn-icon"><mat-icon>cloud_download</mat-icon></span>
        <span class="hide-on-small">{{ 'GALAXY.TABLE.CONTENT_HEADER.EXPORT' | translate }}</span>
      </button>
    }
  </div>
</div>
@if (showFilters) {
  <div class="glxy-filter-bar" [@openClose]="showFiltersOpen ? 'open' : 'closed'">
    <div class="glxy-filter-bar-inner-space">
      <ng-content select="[filters-area]" />
    </div>
  </div>
}
<glxy-table-selection-bar
  [selectAllAvailable]="selectAllAvailable"
  [showActions]="!!showActions"
  [hideActionButton]="hideActionButton"
  [pageScopeTemplate]="pageScopeTemplate"
  [selectAllPromptTemplate]="selectAllPromptTemplate"
  [allMatchingTemplate]="allMatchingTemplate"
  (selectAllToggled)="selectAllToggled.emit()"
  (selectionCleared)="selectionCleared.emit()"
>
  <ng-content select="[mat-menu-item]" ngProjectAs="[mat-menu-item]" />
</glxy-table-selection-bar>
